/**
 * Product Form (PDP Add to Cart)
 * Intercepts the main product form submission and adds the item via AJAX,
 * so the cart drawer opens instead of a full page navigation.
 */

(function () {
  async function handleSubmit(event) {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;

    event.preventDefault();

    const submitBtn = form.querySelector('[data-add-to-cart]');
    const loader = form.querySelector('[data-loader]');
    const textEl = form.querySelector('[data-add-to-cart-text]');
    const errorWrapper = form.querySelector('[data-error-message-wrapper]');
    const errorMessage = form.querySelector('[data-error-message]');

    if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') return;
    if (submitBtn && submitBtn.classList.contains('is-loading')) return;

    if (errorWrapper) errorWrapper.classList.add('product-form__error-message-wrapper--hidden');
    if (submitBtn) submitBtn.classList.add('is-loading');
    if (loader) loader.classList.remove('hide');

    try {
      const formData = new FormData(form);
      // Ask Shopify to render the cart drawer with the add, so the drawer can
      // open already showing this item (see cart-drawer.js open()).
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        const message = data.description || data.message || 'Unable to add this item to your cart.';
        throw new Error(message);
      }

      document.dispatchEvent(
        new CustomEvent('cart:item-added', {
          bubbles: true,
          detail: { variantId: data.id, productTitle: data.product_title, sections: data.sections },
        })
      );

      if (textEl) {
        if (!textEl.dataset.defaultText) textEl.dataset.defaultText = textEl.textContent;
        textEl.textContent = 'Added';
      }

      setTimeout(() => {
        if (textEl && textEl.dataset.defaultText) textEl.textContent = textEl.dataset.defaultText;
      }, 2000);
    } catch (error) {
      if (errorWrapper && errorMessage) {
        errorMessage.textContent = error.message;
        errorWrapper.classList.remove('product-form__error-message-wrapper--hidden');
      }
      console.error('[ProductForm] Error adding item to cart', error);
    } finally {
      if (submitBtn) submitBtn.classList.remove('is-loading');
      if (loader) loader.classList.add('hide');
    }
  }

  document.addEventListener('submit', handleSubmit);
})();
